import { Link } from 'react-router-dom';
import { heroStats, tickerTopics, siteInfo } from '@/mocks/site';

const tickerRow = [...tickerTopics, ...tickerTopics];

export default function Hero() {
  return (
    <section className="relative w-full min-h-[640px] md:min-h-[720px] flex flex-col justify-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20warm-toned%20archive%20room%20with%20towering%20shelves%20of%20manila%20folders%20and%20scattered%20paper%20documents%20on%20a%20wooden%20table%2C%20a%20glowing%20amber%20desk%20lamp%2C%20dramatic%20shadows%2C%20cinematic%20editorial%20still%2C%20deep%20brick%20red%20and%20amber%20tones%2C%20no%20blue%20hues%2C%20abstract%20artistic%20atmosphere%2C%20high%20detail&width=1600&height=1000&seq=hero-archive-room&orientation=landscape"
          alt="档案室中堆叠的卷宗与暖光灯，象征爆料短剧的真实事件对照工作"
          title="剧真档案 - 爆料短剧真实事件改编确认与原型人物对照"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 md:pt-32 pb-14">
        <div className="w-full max-w-5xl mx-auto text-center">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 text-background-100 text-xs font-label tracking-wider mb-6 animate-fade-in">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
            {siteInfo.brandEn} · 内容比对型档案站
          </p>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-[56px] font-black text-background-50 leading-tight tracking-tight">
            {siteInfo.brand}
            <span className="block mt-3 text-lg md:text-2xl lg:text-3xl font-semibold text-background-100/95">
              看爆料短剧前，先分清哪段是真的
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-background-200/90 leading-relaxed max-w-2xl mx-auto">
            真实事件改编确认、剧情原型人物是谁、改编程度分析到不到位、与真实爆料对比差多少，片尾声明又该怎么读——我们把这几件事拆开，一条一条摆给你看。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <Link
              to="/dramas"
              className="px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-search-eye-line text-base"></i>
              进入档案库对照
            </Link>
            <Link
              to="/#method"
              className="px-6 py-3.5 rounded-md border border-background-50/35 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-list-check-2 text-base"></i>
              看我们怎么核对
            </Link>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-background-50/15">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-background-50/10">
          {heroStats.map((stat) => (
            <div key={stat.label} className="px-4 py-6 md:py-7 text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                {stat.value}
                <span className="text-xs font-body text-background-200/70 ml-1">{stat.suffix}</span>
              </p>
              <p className="mt-1.5 text-xs md:text-sm text-background-200/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full overflow-hidden bg-primary-950/70 border-t border-background-50/10 py-2.5">
        <div className="flex w-max animate-ticker">
          {tickerRow.map((topic, idx) => (
            <span
              key={`${topic}-${idx}`}
              className="flex items-center gap-2 px-5 text-xs text-background-200/70 font-label whitespace-nowrap"
            >
              <i className="ri-checkbox-blank-circle-fill text-[5px] text-accent-400"></i>
              {topic}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}